import styled from 'styled-components';
import OrangeRightArrow from "../../../../assests/images/orange-right-arrow.svg";

export const InviteReviewTopSec = styled.section`
    width: 100%;
    
     @media screen and (max-width: 991px){
     padding-top: 100px;
     }

    @media screen and (max-width: 575px){
        padding-top: 0px;
    }

    .row {
        align-items: center;
    }
    .search-header{
        display:none;  
    }
    p {
        padding-bottom: 25px;
        &:last-child{
            padding-bottom: 0px;
        }
    }
    a{
        color:#01606F;
        font-weight: bold;
        display: block;
    }
    .invite-reviews-title{
        max-width: inherit;
    }

    .invite-review-banner{
        
        @media screen and (max-width: 1024px){
            padding-top: 170px;
        }
        @media screen and (max-width: 991px){
            padding-top: 70px;
        }
        @media screen and (max-width: 767px){
            padding-top: 50px;
        }
    }
`;

export const SocialMediaGroup = styled.section`
    width: 100%;
    padding: 50px 0px;
    background: #F1FEFF;
    
    @media screen and (max-width: 767px){
        padding: 40px 0px;
    }

    .social-media-detail-main{
        width: 100%;
        background: #F1FEFF;

        @media screen and (max-width: 767px){
            max-width: 100%;
        }

        .social-media-req-main{
            background: #fff;
            padding: 20px 5px;
            border-radius: 20px;
            box-shadow: 0px 20px 20px #0000001A;
            
            @media screen and (max-width: 767px){
                padding-top: 0px;
            }
        }
    }

    .row{
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-wrap: wrap;
        row-gap: 20px;
    }

    .ideas-collecting-reviews{
        display: none;
    }
`;


export const SocialMediaDetailMain = styled.div`
    
    
`;

export const InviteReviewsSMSSection = styled.section`
    width: 100%;
    background: #F1FEFF;
    padding-bottom: 50px;

    @media screen and (max-width: 575px){
        padding-bottom: 40px;
    }

`;

export const InviteReviewsSMSWrap = styled.div`
    max-width: 996px;
    margin: 0 auto;
    padding: 20px;
    color: #333333;
    font-size: 18px;
    font-family: 'Jost', sand-serif;
    font-weight: 400;
    line-height: 22px;
    border: 1px solid #000000;
    border-radius: 20px;
    background: #fff;

    @media screen and (max-width: 575px){
        border-radius: 15px;
        padding: 15px;
    }
`;

export const InviteReviewsSmsTitle = styled.h2`
    color: #333333;
    font-size: 30px;
    font-family: 'Jost', sans serif;
    font-weight: 600;
    line-height: 44px;
    margin-bottom: 20px;
    
    @media screen and (max-width: 991px){
        font-size: 26px;
        line-height: 38px;
    }
    
    @media screen and (max-width: 575px){
        font-size: 24px;
        line-height: 34px;
        margin-bottom: 15px;
    }
`;

export const InviteReviewsSmsText = styled.p`
    margin-bottom: 20px;

    @media screen and (max-width: 575px){
        margin-bottom: 15px;
    }

    &:last-child{
        margin-bottom: 0;
    }
`;

export const InviteReviewsSmsSubTitle = styled.h3`
    color: #333333;
    font-size: 20px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 30px;
    margin: 30px 0px 15px;

    @media screen and (max-width: 991px){
        margin: 30px 0px 20px;
    }
`;
export const SmsReviewWrap = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    column-gap: 30px;

    @media screen and (max-width: 991px){
        flex-direction: column;
        row-gap: 30px;
    }
`;

export const SmsReviewImage = styled.div`
    width: 100%;
    max-width: 240px;

    img{
        width: 100%;
        height: 100%;
        display: inline-block;
    }
`;

export const SmsReviewContent = styled.div`
    width: 100%;    
    max-width: 650px;
    color: #333333;
    font-size: 16px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 24px;
`;

export const SmsReviewUnorderedList = styled.ul`
    width: 100%;
    max-width: 650px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    row-gap: 12px;
    list-style: none;
    padding-left: 0;
    margin-bottom: 0px;

    @media screen and (max-width: 991px){

    }
`;

export const SmsReviewList = styled.li`
    width: 100%;
    padding-left: 31px;
    position: relative;
    color: #333333;
    font-size: 16px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 22px;

    &::before{
        content: '';
        position: absolute;
        width: 20px;
        height: 20px;
        background: url();
        background-image:url(${OrangeRightArrow});
        background-repeat: no-repeat;
        background-size: contain;
        background-position: top left;
        left: 0;
        top: 0;

        @media screen and (max-width: 480px){
            width: 16px;
            height: 16px;
            top: 3px;
        }
    }
`;

export const SmsReviewListStrong = styled.strong`
    color: #01606F;
    font-size: 16px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
`;

export const SmsReviewTextLine = styled.p`
    max-width: 584px;
    margin: 20px 0px 0px;

    @media screen and (max-width: 991px){
        max-width: 100%;
    }
`;

export const SmsReviewTextBox = styled.div`
    width: 100%;
    margin-top: 20px;
    img{
        width: 100%;
        display: inline-block;
    }
`;

export const WhyUseSmsSection = styled.section`
    width: 100%;
    background: #F1FEFF;
    padding: 0px 0px 50px;

    @media screen and (max-width: 575px){
        padding: 0px 0px 40px;
    }
`;

export const WhyUseSmsWrap = styled.div`
    width: 100%;
    background: #FFFFFF;
    padding: 20px;
    border-radius: 20px;
    box-shadow: 0px 20px 20px #0000001A;
`;

export const WhyUseSmsTitle = styled.h2`
    color: #333333;
    font-size: 30px;
    font-family: 'Jost', sans serif;
    font-weight: 600;
    line-height: 44px;
    margin-bottom: 20px;
    
    @media screen and (max-width: 991px){
        font-size: 26px;
        line-height: 38px;
    }
    
    @media screen and (max-width: 575px){
        font-size: 24px;
        line-height: 34px;
    }
`;


export const WhyUseSmsUnorderedList = styled.ul`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    row-gap: 12px;
    list-style: none;
    padding-left: 0px;
    margin-bottom: 0px;
`;

export const WhyUseSmsList = styled.li`
    color: #333;
    font-size: 16px; 
    font-weight: 4  00;
    font-family: 'Jost', sans serif;
    line-height: 24px;
    padding-left: 31px;
    position: relative;

    &::before{
        content: '';
        position: absolute;
        width: 20px;
        height: 20px;
        background: url();
        background-image:url(${OrangeRightArrow});
        background-repeat: no-repeat;
        background-size: contain;
        background-position: top left;
        left: 0;
        top: 0;
        
        @media screen and (max-width: 480px){
            width: 16px;
            height: 16px;
            top: 3px;
        }
    }
`;

export const WhyUseSmsListStrong = styled.strong`
    color: #01606F;
    font-size: 16px; 
    font-weight: 700;
    font-family: 'Jost', sans serif;
    line-height: 24px;   
`;

export const InviteClientsWrap = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    column-gap: 40px;

    @media screen and (max-width: 575px){
        flex-direction: column;
        row-gap: 40px;
    }
`;

export const InviteClientsUnorderedList = styled.ul`
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    row-gap: 20px;
    list-style: none;
    padding-left: 0;
    margin-bottom: 0;
`;

export const InviteClientsList = styled.li`
    color: #000000;
    font-size: 16px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 24px;
`;

export const InviteClientsStrong = styled.strong`
    color: #01606F;
    display: block;
`;

export const InviteClientsImage = styled.div`

`;

export const InviteClientsBox = styled.div`

`;

export const InviteClientButton = styled.div`
    
    .docx-template-btn{
        width: 100%;
        max-width: 320px;
        background: #FFC380;
        color: #57330A;
        border-radius: 10px;
        padding: 13px 20px;
        font-size: 16px;
        font-family: 'Jost', sans-serif;
        font-weight: 500;
        line-height: 22px;
        border: none;
        margin-top: 30px;
        box-shadow: 3px 5px 20px #00000033;
        transition: all 0.2s ease-in-out;

        @media screen and (max-width: 575px){
            margin-top: 20px;
            max-width: 100%;
        }

        &:hover{
            background: #FFFFFF;
            color: #000000;
        }
    }
`;


export const CollectingReviewsSection = styled.section`
    width: 100%;
    padding-bottom: 50px;
    background: #F1FEFF;

    @media screen and (max-width: 575px){
        padding-bottom: 40px;
    }

    .collecting-reviews-main{
        background: #fff;
        padding: 20px 5px;
        border-radius: 20px;
        box-shadow: 0px 20px 20px #0000001A;

        @media screen and (max-width: 575px){
            padding-top: 0px;
        }
    }
`;

export const CollectingReviewsWrap = styled.div`
    width: 100%;
    margin-bottom: 32px;
    color: #000000;
    font-size: 16px;
    font-family: 'Jost', sans serif;
    font-weight: 400;
    line-height: 24px;

    @media screen and (max-width: 991px){
        margin-bottom: 22px;
    }
`;

export const CollectingReviewsTitle = styled.h2`
    color: #333333;
    font-size: 30px;
    font-family: 'Jost', sans serif;
    font-weight: 600;
    line-height: 44px;
    margin-bottom: 20px;

    @media screen and (max-width: 991px){
        font-size: 26px;
        line-height: 38px;
        margin-bottom: 15px;
    }
    
    @media screen and (max-width: 575px){
        font-size: 24px;
        line-height: 34px;
        margin-bottom: 10px;
    }

    @media screen and (max-width: 480px){
        font-size: 22px;
        line-height: 30px;
    }
`;


export const CollectingReviewsText = styled.p`
    max-width: 1080px;
    margin-bottom: 0px;
`;

export const CollectingReviewsStrong = styled.strong`
    color: #01606F;
    font-weight: 600;
    margin: 0px;
`;

export const CollectingReviewsGroup = styled.div`
    width: 100%;
    column-count: 2;
    counter-reset: item-counter;

    @media screen and (max-width: 991px){
        column-count: 1;
    }

`;

export const ClientCollectingReviewsBox = styled.div`
    width: 100%;
    margin-bottom: 20px;
    break-inside: avoid;
    @media screen and (max-width: 991px){
        margin-bottom: 15px;
    }

    &:last-child{
        margin-bottom: 0px;
        
        @media screen and (max-width: 991px){
            margin-bottom: 15px;
        }
    }

    .social-media-requests-box-title{
        display: none;
    }

    .social-media-req-ul{
        display: none;
    }

    .social-media-requests-box{
        break-inside: avoid;
    }
`;